import React   from "react";
import Receipt from "../../../components/Receipt";
import View    from "./view";

export default class ReceiptView extends View {
    static get title () {
        return "статус";
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            receiptData: React.PropTypes.object.isRequired,
            receiptInfo: React.PropTypes.string.isRequired,
        });
    }

    

    render() {

        console.log('receiptInfo', this.props.receiptInfo);

        return (
            <div className="appointment-view appointment-view--receipt">
                <div className="appointment-view--info">
                    { this.props.receiptInfo ? this.props.receiptInfo : "Ваша бронь подтверждена" }
                </div>
                <Receipt data={this.props.receiptData} confirmed={true} />
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/receipt.js
 **/